import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputMasked from "react-input-mask";

import api from "../../../service/api";
import { changeUser } from "../../../redux/actions/login";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Modal from "../../../components/ModalSuccessMessage";
import Dropzone from "../../../components/Dropzone";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import ErrorMessage from "../../../components/ErrorMessage";

import { 
    LogoContainer, 
    LogoBackground, 
    Logo, 
    DropzoneContainer, 
    ContainerTitle, 
    TranparentButton, 
    ButtonContainerForLargeDevices, 
    ButtonContainerForSmallDevices,
    FieldLabel,
    ContainerColors,
    ContainerInputColor,
    LengthTextArea,
    ContainerTextArea
} from  "./styles";

import routes from "../../../routes/configuration.routes";
import Main from "../../../components/Main/index";

//Assets
import logo from "../../../assets/img/sifrapag-logo.png";

//Interface
import { MyCadastreInterface } from "./interfaces";

//Help Functions
import { openModal } from "../../../helpers/modalFunctions";
import { Textarea } from "./styles";
import { addressImage } from "../../../service/domains";

const MyRegister = () => {
    const [logoImg, setLogoImg] = useState<File>();
    const [logoTransparentImg, setLogoTransparentImg] = useState<File>();
    const [backgroundImg, setBackgroundImg] = useState<File>();

    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);

    const [branchData, setBranchData] = useState<MyCadastreInterface>({
        address: "",
        background: "",
        businessDescription: "",
        businessCategory: "",
        businessEmail: "",
        businessName: "",
        businessPhone: "",
        city: "",
        codePostal: "",
        complement: "",
        datahora_cad: "",
        neighborhood: "",
        number: "",
        standardLogo: "",
        statementDescriptor: "",
        state: "",
        taxpayerIdBranch: "",
        translucidLogobackground: "",
        primaryColor: "",
        secundaryColor: "",
        businessFacebook: "",
        businessInstagram: "",
        businessWhatsapp: "",
        storyDescription: "",
        businessWebSite: "",
    });

    const login = useSelector((state: {login: any}) => state.login);
    const dispatch = useDispatch();
    const history = useHistory();
    
    useEffect(() => {
        if(login.user.groups.cm6a1 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    useEffect(() => {
        const getBranchInfos = async () => {
            const {data} = await api.get("/adm/ownerbranch/list", {
                params: {
                    branchId: login.user.branchsId
                }
            });

            setBranchData(data.Branch[0].Branch);
        }

        getBranchInfos();
    }, []);

    function handleAvatarDownload(){
        const url = `${addressImage}${login.user.avatar}`;
        const fileName = login.user.avatar;
        var xhr = new XMLHttpRequest();
        
        xhr.open("GET", url, true);
        xhr.responseType = "blob";
        xhr.onload = function(){
            var urlCreator = window.URL || window.webkitURL;
            var imageUrl = urlCreator.createObjectURL(this.response);
            var tag = document.createElement("a");
            
            tag.href = imageUrl;
            tag.download = fileName;
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
        }
        xhr.send();
    }

    const formValidationWithYup = Yup.object().shape({
        cnpj: Yup.string().nullable(),
        social: Yup.string().nullable(),
        creationDate: Yup.string().nullable(),
        businessCategory: Yup.string().nullable(),
        email: Yup.string().nullable(),
        fantasyName: Yup.string().nullable(),
        phoneNumber: Yup.string().nullable(),
        postalCode: Yup.string().nullable(),
        address: Yup.string().nullable(),
        addressNumber: Yup.string().nullable(),
        complement: Yup.string().nullable(),
        neighborhood: Yup.string().nullable(),
        city: Yup.string().nullable(),
        state: Yup.string().nullable(),
    })

    return(
        <Main>
            <Header title="Configuração" subTitle="Altere as configurações gerais do sistema caso seja nescessário" subTitleWidth={271}/>
            <NavTabs tabs={routes}/>
            <Modal text="Alterações Realizadas com Sucesso"/>

            <Formik 
                    initialValues={{
                        cnpj: "",
                        social: "",
                        creationDate: "",
                        businessCategory: "",
                        email: "",
                        fantasyName: "",
                        phoneNumber: "",
                        postalCode: "",
                        address: "",
                        addressNumber: "",
                        complement: "",
                        neighborhood: "",
                        city: "",
                        state: "",
                        primaryColor: "",
                        secundaryColor: "",
                        businessInstagram: "",
                        businessFacebook: "",
                        storyDescription: "",
                        businessWhatsapp: "",
                        businessWebSite: "",
                    }}
                    validationSchema={formValidationWithYup}
                    onSubmit={async (values) => {
                        const phoneNumber = values.phoneNumber.replace("(", "").replace(")", "").replace("-", "").split(" ").join("");
                        
                        try {
                            const logoImgData = new FormData();

                            if(logoImg){
                                logoImgData.append("logomarca", logoImg);

                                const {data} = await api.patch(`/branch/logomarca?id=${login.user.branchs.id}`, logoImgData);
                                
                                dispatch(changeUser({...login.user, branchs: data}));
                            }

                            await api.put("/configuration/update", 
                                {
                                    address: values.address,
                                    businessCategory: values.businessCategory,
                                    businessEmail: values.email,
                                    businessName: values.social,
                                    businessPhone: phoneNumber,
                                    city: values.city,
                                    codePostal: values.postalCode,
                                    complement: values.complement,
                                    datahora_cad: values.creationDate,
                                    neighborhood: values.neighborhood,
                                    number: values.addressNumber,
                                    businessDescription: values.fantasyName,
                                    state: values.state,
                                    taxpayerIdBranch: values.cnpj,
                                    storyDescription: values.storyDescription,
                                    primaryColor: values.primaryColor,
                                    secundaryColor: values.secundaryColor,
                                    businessInstagram: values.businessInstagram,
                                    businessFacebook: values.businessFacebook,
                                    businessWhatsapp: values.businessWhatsapp,
                                    businessWebSite: values.businessWebSite,
                                }
                            );
                            setErrorOnReturnApi(false);
                            openModal("exampleModal")
                        } catch (error) {
                            setErrorOnReturnApi(true);
                        }
                    }}
                >
                    {({initialValues, values, handleChange, errors}) => {
                        initialValues.address = branchData.address;
                        initialValues.addressNumber = branchData.number;
                        initialValues.businessCategory = branchData.businessCategory;
                        initialValues.city = branchData.city;
                        initialValues.cnpj = branchData.taxpayerIdBranch;
                        initialValues.complement = branchData.complement;
                        
                        let creationDate = branchData.datahora_cad !== null ? branchData.datahora_cad.split("T"): null;
                        
                        creationDate = creationDate !== null ? creationDate[0].split("-") : null;
                        
                        initialValues.creationDate = creationDate !== null ? `${creationDate[2]}/${creationDate[1]}/${creationDate[0]}` : "";
                        initialValues.email = branchData.businessEmail;
                        initialValues.fantasyName = branchData.businessDescription;
                        initialValues.neighborhood = branchData.neighborhood;
                        initialValues.phoneNumber = branchData.businessPhone;
                        initialValues.postalCode = branchData.codePostal;
                        initialValues.social = branchData.businessName;
                        initialValues.state = branchData.state;
                        initialValues.primaryColor = branchData.primaryColor;
                        initialValues.secundaryColor = branchData.secundaryColor;
                        initialValues.businessInstagram = branchData.businessInstagram;
                        initialValues.businessFacebook = branchData.businessFacebook;
                        initialValues.businessWhatsapp = branchData.businessWhatsapp;
                        initialValues.storyDescription = branchData.storyDescription;
                        initialValues.businessWebSite = branchData.businessWebSite;

                        return(
                            <Form>
                                <div className="row">
                                    <div className="col-12 col-lg-4">
                                    <fieldset>
                                            <ContainerTitle>Ecommerce</ContainerTitle>

                                            <ContainerColors>
                                                <ContainerInputColor>
                                                    <FieldLabel htmlFor="primaryColor">Cor primária</FieldLabel>
                                                    <Field id="primaryColor" name="primaryColor" className="inputCustom color" type="color" as={Input}/>
                                                </ContainerInputColor>
                                                <ContainerInputColor>
                                                    <FieldLabel htmlFor="secundaryColor">Cor secundária</FieldLabel>
                                                    <Field id="secundaryColor" name="secundaryColor" className="inputCustom color" type="color" as={Input}/>
                                                </ContainerInputColor>
                                            </ContainerColors>

                                            <FieldLabel htmlFor="businessInstagram">Link do instagram</FieldLabel>
                                            <Field id="businessInstagram" name="businessInstagram" className="inputCustom" placeholder="Instagram" as={Input}/>

                                            <FieldLabel htmlFor="businessFacebook">Link do facebook</FieldLabel>
                                            <Field id="businessFacebook" name="businessFacebook" className="inputCustom" placeholder="Facebook" as={Input}/>
                                            
                                            <FieldLabel htmlFor="businessWhatsapp">Whatsapp do estabelecimento</FieldLabel>
                                            <Field 
                                                name="businessWhatsapp" 
                                            >
                                                {() => (
                                                    <InputMasked
                                                        id="businessWhatsapp" 
                                                        className="input-masked inputCustom"
                                                        placeholder="Whatsapp" 
                                                        mask="(99) 99999-9999"
                                                        maskChar={null}
                                                        value={values.businessWhatsapp}
                                                        onChange={handleChange}
                                                    />
                                                )}
                                            </Field>
                                            
                                            <FieldLabel htmlFor="businessWebSite">Nome da loja virtual</FieldLabel>
                                            <Field id="businessWebSite" name="businessWebSite" className="inputCustom" placeholder="Nome a ser exibido na loja virtual" as={Input}/>

                                            <FieldLabel htmlFor="storyDescription">Descrição da loja</FieldLabel>
                                            <ContainerTextArea>
                                                {
                                                    values.storyDescription
                                                    ? <>
                                                        Número de caracteres restantes:
                                                        <LengthTextArea> {123 - values.storyDescription.length}</LengthTextArea>
                                                    </>
                                                    : null
                                                }
                                                
                                            </ContainerTextArea>
                                            <Field id="storyDescription" maxLength={123} rows={3} cols={42} name="storyDescription" className="inputCustom" placeholder="Descrição da loja" as={Textarea}/>

                                            <LogoContainer>
                                                <LogoBackground>
                                                    <Logo src={login.user.branchs.standardLogo !== null ? `${addressImage}${login.user.branchs.standardLogo}` : logo}/>
                                                </LogoBackground>
                                            </LogoContainer>

                                            <DropzoneContainer>
                                                <div className="w-100">
                                                    <ContainerTitle>Logomarca Padrão</ContainerTitle>
                                                    <Dropzone onFileUploaded={setLogoImg} type="image/png"/>
                                                    <div className="d-flex justify-content-center mt-2">
                                                        <TranparentButton type="button" onClick={() => handleAvatarDownload()}>Baixar imagem</TranparentButton>
                                                    </div>
                                                </div>
                                            </DropzoneContainer>
                                        </fieldset>
                                    </div>
                                    
                                    <div className="col-12 col-lg-4">
                                        <fieldset>
                                            <ContainerTitle>Dados Cadastrais</ContainerTitle>
                                            <FieldLabel htmlFor="cnpj">CNPJ</FieldLabel>
                                            <Field id="cnpj" name="cnpj" className="inputCustom" placeholder="CNPJ" as={Input}/>

                                            <FieldLabel htmlFor="social">Razão Social</FieldLabel>
                                            <Field id="social" name="social" className="inputCustom" placeholder="Razão Social" as={Input}/>

                                            <FieldLabel htmlFor="creationDate">Data de criação</FieldLabel>
                                            <Field 
                                                name="creationDate" 
                                                
                                                >
                                                {() => (
                                                    <InputMasked
                                                        id="creationDate" 
                                                        className="input-masked inputCustom" 
                                                        placeholder="Data de criação"
                                                        mask="99/99/9999"
                                                        maskChar={null}
                                                        value={values.creationDate}
                                                        onChange={handleChange}
                                                    />
                                                )}
                                            </Field>

                                            <FieldLabel htmlFor="businessCategory">Categoria do Negócio</FieldLabel>
                                            <Field id="businessCategory" name="businessCategory" className="inputCustom" placeholder="Categoria do Negócio" as={Input}/>

                                            <FieldLabel htmlFor="email">E-mail</FieldLabel>
                                            <Field id="email" name="email" className="inputCustom" placeholder="E-mail" as={Input}/>

                                            <FieldLabel htmlFor="fantasyName">Nome fantasia</FieldLabel>
                                            <Field id="fantasyName" name="fantasyName" className="inputCustom" placeholder="Nome fantasia" as={Input}/>
                                            
                                            <FieldLabel htmlFor="phoneNumber">Telefone</FieldLabel>
                                            <Field 
                                                name="phoneNumber" 
                                            >
                                                {() => (
                                                    <InputMasked
                                                        id="phoneNumber" 
                                                        className="input-masked inputCustom"
                                                        placeholder="Telefone" 
                                                        mask="(99) 99999-9999"
                                                        maskChar={null}
                                                        value={values.phoneNumber}
                                                        onChange={handleChange}
                                                    />
                                                )}
                                            </Field>

                                            
                                        </fieldset>
                                        
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <fieldset>
                                            <ContainerTitle>Endereço</ContainerTitle>
                                            
                                            <FieldLabel htmlFor="postalCode">CEP</FieldLabel>
                                            <Field 
                                                name="postalCode"     
                                            >
                                                {() => (
                                                    <InputMasked
                                                        id="postalCode" 
                                                        className="input-masked inputCustom" 
                                                        placeholder="CEP"
                                                        mask="99999-999"
                                                        value={values.postalCode}
                                                        onChange={handleChange}
                                                    />
                                                )}
                                            </Field>

                                            <FieldLabel htmlFor="address">Endereço</FieldLabel>
                                            <Field id="address" name="address" className="inputCustom" placeholder="Endereço" as={Input}/>

                                            <FieldLabel htmlFor="addressNumber">Número</FieldLabel>
                                            <Field id="addressNumber" name="addressNumber" className="inputCustom" placeholder="Número" as={Input}/>

                                            <FieldLabel htmlFor="complement">Complemento</FieldLabel>
                                            <Field id="complement" name="complement" className="inputCustom" placeholder="Complemento" as={Input}/>

                                            <FieldLabel htmlFor="neighborhood">Bairro</FieldLabel>
                                            <Field id="neighborhood" name="neighborhood" className="inputCustom" placeholder="Bairro" as={Input}/>

                                            <FieldLabel htmlFor="city">Cidade</FieldLabel>
                                            <Field id="city" name="city" className="inputCustom" placeholder="Cidade" as={Input}/>

                                            <FieldLabel htmlFor="state">Estado</FieldLabel>
                                            <Field id="state" name="state" className="inputCustom" placeholder="Estado" as={Input}/>
                                        
                                        </fieldset>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-lg-4">
                                        <ButtonContainerForSmallDevices>
                                            {
                                                errorOnReturnApi ?
                                                    <ErrorMessage>
                                                        Falha ao atualizar informações
                                                    </ErrorMessage> : null
                                            }
                                            <Button type="submit" >Salvar Alterações</Button>
                                        </ButtonContainerForSmallDevices>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-12 col-lg-4">
                                        <ButtonContainerForLargeDevices>
                                            {
                                                errorOnReturnApi ?
                                                    <ErrorMessage>
                                                        Falha ao atualizar informações
                                                    </ErrorMessage> : null
                                            }
                                            <Button type="submit">Salvar Alterações</Button>
                                        </ButtonContainerForLargeDevices>
                                    </div>
                                </div>
                            </Form>
                        )
                    }}
            </Formik>


            
        </Main>
    )
}

export default MyRegister;
